export const DEBOUNCE_DELAY_MS = 150;
export const ENTITY_TYPE = 'File';
export const SUGGESTIONS_POST_ENDPOINT = '/search/api/v1/suggestions?';
export const MAX_ENTRIES_TYPEDOWN = '5';
export const MAX_ENTRIES_DIRECTORY = '20';
